export default __webpack_public_path__ + "static/Behemoth_Gate-740a02982d3f2026f010de456b19d4b5.png";